<template>
  <div class="bundle-list">
    <!-- Toast component and its position -->
    <Toast position="top-right" />
    
    <!-- Navigation Component -->
    <navigation />
    <div class="displayRow">
      <FileUpload v-tooltip="'Import new bundles'" class="p-mr-2"  mode="basic" ref="file" name="file" :customUpload="true" accept=".csv" :maxFileSize="1000000" @uploader="uploadFile" :auto="true" chooseLabel="Import" />
    </div>

    <div class="data-table-parent-container bunChart">
      <DataTable
        dataKey="id" 
        ref="data"
        :paginator="true"
        scrollDirection="horizontal"
        :scrollable="true"
        :rows="20"
        :value="isLoaded ? bundleData : skeletonData"
        sortField="ods_created_at"
        :sortOrder="-1"
        :filters="filters"
        :resizableColumns="true" columnResizeMode="fit"
        :globalFilterFields="['bundle_name','bundle_sku','variant_sku','actual_sku']"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
        :rowsPerPageOptions="[20,40,60,80,100,200]"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records">

      <template #header>
        <div>
          <div class="p-grid searchBoxes p-ai-center vertical-container">
            <div class="p-col-2">Bundles<br>
              <span class="records-count">Total {{bundleCount}} Records</span>
            </div>
            <div class="p-offset-6 search-row">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText placeholder="Bundle Name Search" v-model="filters['bundle_name'].value"/>
              </span>
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText placeholder="Global Search" v-model="filters['global'].value"/>
              </span>
            </div>
          </div>
        </div>
      </template>
      
      <Column v-for="(column,i) in columns" :field="column.field" :header="column.header" :sortable="column.sortable" :headerStyle="`width:${column.width}`" :key="i">
        <template v-if="column.filter" #filter>
          <InputText type="text" v-model="filters[column.field]" class="p-column-filter" :placeholder="`Search by ${column.header}`"/>
        </template>
        <template #body v-if="!isLoaded">
          <Skeleton></Skeleton>
        </template>
      </Column>
    </DataTable>
  </div>

  <div class="invalModal">
    <Dialog :visible="display" >
      <template #header>
        <h3>These items have not been added <br/><span>Please fix invalid (red) cell(s) and reimport</span></h3>
        <p>Bundle sku is required - ex: 2284 <br/>
          Variant sku is required - ex: 2284:L <br/>
          Actual sku is required - ex: 130000:2581:L <br/><br/>
          <strong>*NO WHITE SPACE IN SKUs</strong>
        </p>
      </template>
      <DataTable
        dataKey="id" 
        ref="vdata"
        editMode="cell"
        @cell-edit-complete="onCellEditComplete"
        class="editable-cells-table"
        :paginator="true"
        scrollDirection="horizontal"
        :scrollable="true"
        :rows="10"
        :value="invalidData"
        :rowClass="inClass"
        style="width: 100%">
          <Column v-for="(column,i) in inVcolumns" :field="column.field" :header="column.header" :key="i">
            <template #editor="{ data, field }">
              <InputText v-model="data[field]" autofocus  />
            </template>
          </Column>
        <template #footer>
          <Button label="Reimport" icon="pi pi-upload" class="exportModal" @click="uploadFileAgain()" v-if="showInvalBtn"  />
        </template>
      </DataTable>
    </Dialog>
  </div>

  </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import FileUpload from "primevue/fileupload";
import Button from "primevue/button";
import http from "../../http-common";
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import Tooltip from 'primevue/tooltip';
import navigation from "../../components/helperComponents/menu";
import Skeleton from 'primevue/skeleton';
import {FilterMatchMode} from 'primevue/api';
import Dialog from 'primevue/dialog'

export default {
  name: "bundle",
  components: {
    navigation,
    Textarea,
    Button,
    FileUpload,
    Toolbar,
    DataTable,
    Column,
    InputText,
    Toast,
    Skeleton,
    Dialog
  },
  directives: {
    'tooltip': Tooltip
  },
  data() {
    return {
      file: '',
      bundleData: [],
      invalidData: [],
      dup: [],
      editingRows: [],
      showDialog: false,
      bundleRecord: {},
      filters: {
        'global':  {value: null, matchMode: FilterMatchMode.EQUALS},
        'bundle_name': {value: null, matchMode: FilterMatchMode.CONTAINS}
      },
      submitted: false,
      enableSaveClonedCTA: false,
      display: false,
      showInvalBtn: false,
      apiUrlPath: 'api/bundle',
      columns: [
        {field: 'ods_created_at', header: 'Date created', sortable: true, filter: 'text'},
        {field: 'division', header: 'Division', sortable: true, filter: 'text'},
        {field: 'bundle_name', header: 'Bundle Name', sortable: true, filter: 'text'},
        {field: 'bundle_sku', header: 'Bundle SKU', sortable: true, filter: 'text'},
        {field: 'variant_sku', header: 'Variant SKU', sortable: true, filter: 'text'},
        {field: 'bundle_contents', header: 'Bundle Contents', sortable: true, filter: 'text'},
        {field: 'actual_sku', header: 'Actual SKU', sortable: true, filter: 'text'},
        {field: 'quantity', header: 'Quantity', sortable: true, filter: false},
      ],
      inVcolumns: [
        {field: 'division', header: 'division', width: '100px', sortable: true, filter: 'text'},
        {field: 'bundle_name', header: 'bundle_name', width: '250px', sortable: true, filter: 'text'},
        {field: 'bundle_sku', header: 'bundle_sku', width: '250px', sortable: true, filter: 'text'},
        {field: 'variant_sku', header: 'variant_sku', width: '250px', sortable: true, filter: 'text'},
        {field: 'bundle_contents', header: 'bundle_contents', width: '250px', sortable: true, filter: 'text'},
        {field: 'actual_sku', header: 'actual_sku', width: '250px', sortable: true, filter: 'text'},
        {field: 'quantity', header: 'quantity', width: '250px', sortable: true, filter: false},
        {field: 'message', header: 'message', width: '250px', sortable: true, filter: 'text'},
      ],
      skeletonData: Array(20)
    }
  },
  computed: {
    isLoaded(){
      return this.bundleData.length > 0
    },
    bundleCount(){
      return this.bundleData.length
    }
  },
  mounted() {
    this.getThisBundle();
  },
  methods: {
    getThisBundle(){
      http
      .get(`${this.apiUrlPath}/bundle-entries`)
      .then((response) => {
        this.bundleData = response.data
      })
      .catch((err) => window.console.log(err))
    },
    inClass(invalidData) {
      if(invalidData !== undefined){
        return [{
          'notVal': !(/^\d+$/.test(invalidData.bundle_sku)),
          'notVal2': !(/^\d+$/.test(invalidData.quantity)),
          'notVal3': !(/^\d+:[a-zA-Z]+$/.test(invalidData.variant_sku)),
          'notVal4': !(/\d+:\d+:[a-zA-Z]+/.test(invalidData.actual_sku))
         }]
      }
    },
    onCellEditComplete(event) {
      let { data, newValue, field } = event
      switch (field) {
        default:
          if (newValue.trim().length > 0) data[field] = newValue;
          else event.preventDefault();
        break;
      }
      this.showInvalBtn = true
    },
    openNewDialog(){
      this.display = true;
    },
    closeNewDialog(){
      this.display = false;
    },
    uploadFile(){
      this.file = this.$refs.file.files[0];
      let reader = new FileReader()
      let fix = []
      reader.onload = () => {
        let splitit = reader.result.split(/\n/)
        let jsonObj = []
        let headersArr = splitit[0].replace(/['"]+/g, '').split(',')
        for(let i = 1; i < splitit.length; i++) {
          var dataArr = splitit[i].replace(/['"]+/g, '').split(',')
          var objArr = {}
          for(let j = 0; j < dataArr.length; j++) {
             objArr[headersArr[j].trim()] = dataArr[j].trim()
          }
          jsonObj.push(objArr)
        }
        JSON.stringify(jsonObj)

        for(let obj of jsonObj){
          if (obj["bundle_sku"] !== undefined && !(/^\d+$/.test(obj["bundle_sku"]))) {
            obj.message = "INVALID field[s] is highlighted"
            fix.push(obj)
            this.invalidData = fix
          }
          if (obj["quantity"] !== undefined && !(/^\d+$/.test(obj["quantity"]))) {
            obj.message = "QUANTITY is required"
            fix.push(obj)
            this.invalidData = fix
          }
          if ((obj["variant_sku"] !== undefined && !(/^\d+:[a-zA-Z]+$/.test(obj["variant_sku"]))) && (obj["actual_sku"] !== undefined && !(/\d+:\d+:[a-zA-Z]+/.test(obj["actual_sku"])))) {
            obj.message = "INVALID VARIANT SKU & ACTUAL SKU Both SKUs are required and without white space"
            fix.push(obj)
            this.invalidData = fix
          }
          else if (obj["variant_sku"] !== undefined && !(/^\d+:[a-zA-Z]+$/.test(obj["variant_sku"]))) {
            obj.message = "INVALID VARIANT SKU variant_sku is required and without white space"
            fix.push(obj)
            this.invalidData = fix
          }
          else if (obj["actual_sku"] !== undefined && !(/\d+:\d+:[a-zA-Z]+/.test(obj["actual_sku"]))) {
            obj.message = "INVALID ACTUAL SKU actual_sku is required and without white space"
            fix.push(obj)
            this.invalidData = fix
          }
          if(fix.length > 0) this.display = true
        }
      }
      reader.readAsText(this.file)
      let formData = new FormData();
      formData.append('file', this.file);
      http
      .post(`${this.apiUrlPath}/uploadfile`,(formData),
      { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        if(fix.length > 0) {
          this.$toast.add({severity:'warn', summary: 'Success with errors', detail: "Invalid Field[s]", life: 10000})
        }
        else {
          this.$toast.add({severity:'success', summary: 'Success', detail: "Success", life: 10000})
        }
        setTimeout(() => {
          this.getThisBundle()
        }, 7000)
        this.$refs.file.files.pop()
      })
      .catch(err => {
        this.$refs.file.files.pop()
        this.$toast.add({severity:'error', summary: 'Error', detail: err, life: 3000})
      })
    },
    uploadFileAgain(){
      http
      .post(`${this.apiUrlPath}/uploadfileAg`,(JSON.stringify(this.invalidData)),
      { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        this.$toast.add({severity:'success', summary: 'Success', detail: "Success", life: 10000})
        setTimeout(() => {
          this.getThisBundle()
        }, 7000)
        this.display = false
      })
      .catch(err => {
        this.$refs.file.files.pop()
        this.$toast.add({severity:'error', summary: 'Error', detail: err, life: 3000})
      })
    }
  }    
};
</script>

<style>
.custom-dialog .p-inputtext {
  padding: 14px 10px;
  font-size: 16px;
}

.comment-content {
  color: #00424a;
  font-weight: 700;
}
.data-table-parent-container  {
  overflow: hidden;
}

.data-table-parent-container .p-datatable-scrollable-header {
  overflow: unset;
}

.bundle-list .p-dialog-header-icon {
  display: none;
}
.invalModal .p-datatable .p-datatable-footer {
  justify-content: flex-end;
}
.bundle-list .invalModal .p-dialog-header h3 {
  font-size: 17px;
}
.bundle-list .invalModal .p-dialog-header h3 + p {
  font-size: 14px;
}
.bundle-list .invalModal .p-dialog-header h3 span {
  font-size: 12px;
  font-weight: 600;
}

.bundle-list .displayRow, .invalModal .p-datatable-footer {
  display: flex;
  gap: 15px;
  margin-top: 7px;
}

.bundle-list .p-datatable .p-datatable-tbody>tr>td {overflow: auto;}

.records-count {
  color: #4d4d4d;
  font-size: 12px;
  margin-top: 4px;
  white-space: nowrap;
}

.data-table-parent-container .p-paginator-bottom {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.data-table-parent-container .p-datatable table {
  margin-bottom: 0;
  border: none;
}

.data-table-parent-container .p-datatable .p-datatable-scrollable-footer {
  background: unset;
}

.tool-bar-styling.p-toolbar {
  background: #f5f5f5;
  border: 1px solid #00424a;
  padding: 1rem;
  margin: 1rem 0;
}

.tool-bar-styling .p-button-info.p-button, .tool-bar-styling .p-button, .tool-bar-styling .p-button.p-button-help {
  background: #00424a;
  border: 1px solid #00424a;
  color: #fff;
}

.tool-bar-styling .p-button-info.p-button:enabled:hover, .tool-bar-styling .p-button.p-fileupload-choose:hover, .tool-bar-styling .p-button.p-button-help:enabled:hover {
  background: #00424a;
  border: 1px solid #00424a;
  color: #fff;
}

.tool-bar-styling .p-button-info.p-button:disabled{
  background: #fff;
  border: 1px solid #333;
  color: #000;
  cursor: not-allowed;
}

.row-dup {
  background-color: #fca3201c !important;
}
.editable-cells-table td.p-cell-editing {
  padding-top: 0;
  padding-bottom: 0;
}
.notVal td:nth-child(3),
.notVal2 td:nth-child(7),
.notVal3 td:nth-child(4), 
.notVal4 td:nth-child(6) {background: #ff00006e!important;}

.search-row {
  display: flex;
  gap: 10px;
}
.p-grid.searchBoxes {flex-wrap: nowrap;}
</style>